module.exports = __webpack_public_path__ + "static/media/Chat dorado.4d92c57f.svg";